<span class="error-snackbar-text"
    [attr.data-cy]="successSnackbarDataCy.SNACK_BAR">
    <mat-icon fontSet="material-symbols-sharp"
        class="material-symbols-sharp_bold error-snackbar-text__icon">
        check_circle
    </mat-icon>
    {{message}}
</span>
